export class ColorObj
{
    constructor(
        public R: number = 0,
        public G: number = 0,
        public B: number = 0,
        public A: number = 1
    ) { }
}
